var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }